import { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import styles from './BottomNav.module.css'
import { MOBILE_NAV_ITEMS, MOBILE_MORE_ITEMS } from './navItems'
import { useAuth } from '../../auth/AuthContext'
import { MoreMenuModal } from './MoreMenuModal'
import { useChatUnreadTotal } from '../../modules/chat/useChatUnreadTotal'

export function BottomNav() {
  const { hasAnyPermission } = useAuth()
  const location = useLocation()
  const [showMore, setShowMore] = useState(false)
  const chatUnread = useChatUnreadTotal(hasAnyPermission(['chat.use']))

  const moreItems = MOBILE_MORE_ITEMS.filter((item) => !item.requiredPermissions || hasAnyPermission(item.requiredPermissions))
  const isMoreActive = moreItems.some((item) => location.pathname.startsWith(item.to))

  return (
    <>
      <nav className={styles.nav}>
        {MOBILE_NAV_ITEMS.filter((item) => !item.requiredPermissions || hasAnyPermission(item.requiredPermissions)).map(
          (item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => [styles.item, isActive ? styles.itemActive : ''].join(' ')}
            >
              <span className={styles.iconWrap}>
                <span className={styles.icon}>{item.icon}</span>
                {item.to === '/chat' && chatUnread > 0 ? (
                  <span className={styles.badge}>{chatUnread > 99 ? '99+' : chatUnread}</span>
                ) : null}
              </span>
              <span>{item.label}</span>
            </NavLink>
          ),
        )}
        {moreItems.length > 0 ? (
          <button
            type="button"
            className={[styles.item, isMoreActive ? styles.itemActive : ''].join(' ')}
            onClick={() => setShowMore(true)}
          >
            <span className={styles.icon}>⋯</span>
            <span>Mehr</span>
          </button>
        ) : null}
      </nav>
      {showMore ? <MoreMenuModal onClose={() => setShowMore(false)} /> : null}
    </>
  )
}
